import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

const TITLES = {
  '/erp': 'Dashboard',
  '/erp/students': 'Students',
  '/erp/teachers': 'Teachers',
  '/erp/classes': 'Classes & Subjects',
  '/erp/timetable': 'Timetable',
  '/erp/attendance': 'Attendance',
  '/erp/exams': 'Exams & Results',
  '/erp/fees': 'Fee Management',
  '/erp/library': 'Library',
  '/erp/notices': 'Notices',
  '/erp/holidays': 'Holidays',
  '/erp/whatsapp': 'WhatsApp Automation',
  '/erp/reports': 'Reports & Analytics',
  '/erp/settings': 'Settings',
};

export default function ERPLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const title = TITLES[location.pathname] || 'ERP';

  return (
    <div className="app-layout">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      {sidebarOpen && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 199 }}
          onClick={() => setSidebarOpen(false)} />
      )}
      <div className="main-content">
        <Topbar onMenuToggle={() => setSidebarOpen(v => !v)} title={title} />
        <div className="page-content fade-in">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
